<template>
  <div class="card">
    <div v-if="title" class="card-header">{{ title }}</div>

    <div class="card-body">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "Card",

  props: ["title"]
}
</script>



// WEBPACK FOOTER //
// resources/js/components/global/Card.vue